i.chevron-down {
  background-color: transparent;
  background-size: contain;
  height: 8px;
  width: 8px;
  background-image: url("../images/chevron-down.svg");
  display: flex;
  user-select: none;
}

.table-cell-action-button-container {
  position: absolute;
}

.table-cell-action-button {
  justify-content: center;
  border-radius: 20px;
  align-items: center;
  border: 0;
  position: relative;
  width: 20px;
  height: 20px;
  color: #222;
  display: inline-block;
  cursor: pointer;
}

.table-cell-action-button:hover {
  background-color: #eee;
}
